import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
import green from '@material-ui/core/colors/green'
import FormControl from '@material-ui/core/FormControl'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import {FormattedMessage} from 'react-intl'
import {ContextConsumer} from '../Context'
import SpinnerSVG from '../assets/spinner'

const styles = theme => ({
  card: {
    width: 345,
    alignSelf: 'center',
    position: 'relative',
  },
  logoWrapper: {
    width: 304,
    height: 80,
    margin: '20px auto 0',
  },
  container: {
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
  },
  cardContent: {
    paddingTop: 0,
  },
  textField: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
  },
  checked: {
    color: green[500],
    '& + $bar': {
      backgroundColor: green[500],
    },
  },
  bar: {},
  paper: {
    paddingRight: 20,
    paddingLeft: 20,
    marginTop: 20,
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
  notifyPaper: {
    backgroundColor: 'red',
    padding: 20,
    marginTop: 20,
  },
  notifyVPN: {
    backgroundColor: '#FB1',
    padding: 20,
    marginTop: 20,
  },
  notifyType: {
    color: 'white',
    fontSize: '1rem',
  },
  margin: {
    marginTop: 10,
  },
  switchLabel: {
    fontSize: '1rem',
  },
})

const Login = props => {
  const {classes} = props
  return (
    <ContextConsumer>
      {context => {
        const buttonText =
          context.smsAuth && !context.smsAuthCode ? 'sendCode' : 'logIn'
        return (
          <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
              {context.isMobile && context.notify && (
                <Paper className={classes.notifyPaper}>
                  <Typography
                    variant="body1"
                    align="center"
                    className={classes.notifyType}>
                    <FormattedMessage id="noMatch" />
                  </Typography>
                </Paper>
              )}
              {context.notifyVPN && (
                <Paper className={classes.notifyVPN}>
                  <Typography
                    variant="body1"
                    align="center"
                    className={classes.notifyType}>
                    <FormattedMessage id="hostsCheck" />
                  </Typography>
                </Paper>
              )}
              {context.smsAuthCode ? (
                <Fragment>
                  <TextField
                    id="code-input"
                    label={<FormattedMessage id="enterCode" />}
                    value={context.smsCode}
                    onChange={context.handleChange('smsCode')}
                    className={classes.textField}
                    type="tel"
                    name="smsCode"
                    inputProps={{
                      autoCorrect: 'off',
                      autoComplete: 'new-password',
                      autoCapitalize: 'none',
                    }}
                    margin="normal"
                    error={context.notify}
                    required
                    autoFocus
                  />
                  <Typography variant="caption">
                    Please enter your 4 digit code
                  </Typography>
                </Fragment>
              ) : (
                <Fragment>
                  {context.smsAuth ? (
                    <Fragment>
                      <TextField
                        id="phone-input"
                        label={<FormattedMessage id="phone" />}
                        value={context.phoneNumber}
                        onChange={context.handleChange('phoneNumber')}
                        className={classes.textField}
                        type="tel"
                        name="phoneNumber"
                        inputProps={{
                          autoCorrect: 'off',
                          autoComplete: 'new-password',
                          autoCapitalize: 'none',
                        }}
                        margin="normal"
                        error={context.notify}
                        required
                        autoFocus
                      />
                      <Typography variant="caption">
                        Make sure to include the country code with
                        &quot;&#43;&quot; prefix
                      </Typography>
                      <Typography variant="caption">
                        Example with a USA number: &#43;15551234567
                      </Typography>
                    </Fragment>
                  ) : (
                    <Fragment>
                      <TextField
                        id="username-input"
                        label={<FormattedMessage id="username" />}
                        value={context.username}
                        onChange={context.handleChange('username')}
                        className={classes.textField}
                        type="text"
                        inputProps={{
                          autoCorrect: 'off',
                          autoCapitalize: 'none',
                        }}
                        margin="normal"
                        error={context.notify}
                        required
                        autoFocus
                      />

                      <FormControl
                        className={classes.textField}
                        error={context.notify}
                        required>
                        <InputLabel htmlFor="adornment-password">
                          <FormattedMessage id="password" />
                        </InputLabel>
                        <Input
                          id="adornment-password"
                          type={context.showPassword ? 'text' : 'password'}
                          autoCorrect="off"
                          autoCapitalize="none"
                          value={context.password}
                          onChange={context.handleChange('password')}
                          onKeyPress={context.handleKeyPress}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="Toggle password visibility"
                                onClick={context.handleClickShowPassword}
                                onMouseDown={context.handleMouseDownPassword}>
                                {context.showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          }
                        />
                      </FormControl>
                    </Fragment>
                  )}
                </Fragment>
              )}
            </CardContent>
            <CardActions>
              {context.loading ? (
                <Button
                  variant="raised"
                  size="large"
                  color="primary"
                  className={classes.button}>
                  <SpinnerSVG />
                </Button>
              ) : (
                <Button
                  variant="raised"
                  size="large"
                  color="primary"
                  onClick={
                    context.smsAuth
                      ? context.smsAuthCode
                        ? context.handleVerifyCode
                        : context.handleSendCode
                      : context.handleSendForm
                  }
                  className={classes.button}>
                  <FormattedMessage id={buttonText} />
                </Button>
              )}
            </CardActions>
          </Card>
        )
      }}
    </ContextConsumer>
  )
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js